module.exports = __webpack_public_path__ + "static/img/binzhou2.8f1afa94.jpg";